import React, { useContext } from 'react'
import { HeaderContainer, InfoDiv, SearchDiv, SearchImg, SearchInput, StyledLink, LogoutWrapper } from './style'
import ordenoLogo from '../../assets/sidemenu/ordeno-logo.svg'
import searchImg from '../../assets/headers/search.svg'
import UserContext from '../../contexts/UserContext'
import { TypeMainOutlet } from '../../pages/ClientPanel'
import { LogOut } from 'lucide-react'


const HeaderComponent:React.FC<TypeMainOutlet> = ({search, setSearch}) => {
  const { user } = useContext(UserContext)
  const isTenantClient = (user?.role as string) === 'TENANT_CLIENT'
  
  return(
    <HeaderContainer>
      {isTenantClient ? (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <img src={ordenoLogo} alt='Ordeno logo' draggable='false' />
        </div>
      ) : (
        <StyledLink to={'/panel'}>
          <img src={ordenoLogo} alt='Ordeno logo' draggable='false' />
        </StyledLink>
      )}
      {!isTenantClient && (
        <SearchDiv>
        <SearchInput
          type='text'
          autoComplete='off'
          placeholder='Buscar'
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
        <SearchImg src={searchImg} alt='Search icon' />
      </SearchDiv>
      )}
      <InfoDiv>
  <img src={user.picture} draggable='false' />
  <span>{user.name}</span>
  <LogoutWrapper>
    <LogOut 
      color='#0090D3'
      style={{ cursor: 'pointer' }}
      onClick={() => {
        localStorage.removeItem('token');
        window.location.href = '/login';
      }}
    />
  </LogoutWrapper>
</InfoDiv>
    </HeaderContainer>
  )
}

export default HeaderComponent